import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers-pro';
import { LicenseInfo } from '@mui/x-license-pro';
import React from 'react';
import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client';
import { IntlProvider } from 'react-intl';
import WrappedApp from './App';
import 'tslib';
import { baseTheme } from './theme';

LicenseInfo.setLicenseKey(import.meta.env.VITE_MUI_X_LICENSE_KEY);

(async function () {
  async function loadAxe() {
    return await import('@axe-core/react');
  }
  if (process.env.NODE_ENV?.includes('dev')) {
    const axe = await loadAxe();
    axe.default(React, ReactDOM, 1000);
  }
})();

const container = document.getElementById('root');
const root = createRoot(container as HTMLElement);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={baseTheme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <IntlProvider locale="en">
          <CssBaseline />
          <WrappedApp />
        </IntlProvider>
      </LocalizationProvider>
    </ThemeProvider>
  </React.StrictMode>,
);
